import { Dispatch, SetStateAction } from 'react';
import {
  FlexBetween,
  FlexJustifyCenter,
  HubLengthMessage
} from '../../../styles/stylesStyled';

import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from '../../../App';
import { AnimatedItem } from '../../../components/animation/AnimatedItem';
import { AnimatedTab } from '../../../components/animation/AnimatedTab';
import { USDT, formatUSD } from '../../../helpers/helperFunctions';
import { Button } from '../../../styles/GlobalComponents';
import { InvoiceHeader, Invoices, InvoicesMobile } from '../AccountingStyled';

interface ConversionsPageType {
  conversions: any;
  countConversions: number;
  setCountConversions: Dispatch<SetStateAction<number>>;
}

export const ConversionsPage = ({
  conversions,
  countConversions,
  setCountConversions
}: ConversionsPageType) => {
  const { t } = useTranslation('accounting');

  const TransactionType = (type: string) => {
    switch (type) {
      case 'withdraw':
        return t('withdraw');
      case 'commission':
        return t('commission');
      case 'exchange':
        return t('exchange');
      case 'deposit':
        return t('deposit');
      default:
        return '';
    }
  };

  return (
    <AnimatedTab key={'TransactionsPage'}>
      <Desktop>
        <InvoiceHeader>
          <div style={{ width: '20%' }}>{t('date')}</div>
          <div style={{ width: '20%' }}>{t('transfer_id')}</div>
          <div style={{ width: '20%' }}>{t('type')}</div>
          <div style={{ width: '20%' }}>{t('amount')}</div>
          <div style={{ width: '20%' }}>{t('status')}</div>
        </InvoiceHeader>
      </Desktop>

      {conversions?.length === 0 ? (
        <HubLengthMessage>{t('no_top_ups')}</HubLengthMessage>
      ) : (
        conversions?.map((inv: any, i: number) => {
          return (
            <AnimatedItem index={i} key={i}>
              <Desktop>
                <Invoices>
                  <div style={{ width: '20%' }}>
                    {moment.utc(inv?.dateCreated).format('DD/MM/YY')}
                  </div>
                  <div style={{ width: '20%' }}>#{inv.conversionId}</div>
                  <div style={{ width: '20%' }}>{inv.type}</div>
                  <div style={{ width: '20%' }}>
                    <span>
                      {formatUSD(inv.amount)} {USDT}
                    </span>
                  </div>
                  <div style={{ width: '20%' }}>{inv.status}</div>
                </Invoices>
              </Desktop>
              <Mobile>
                <InvoicesMobile>
                  <FlexBetween>
                    <div
                      style={{
                        fontWeight: 500,
                        lineHeight: '20px'
                      }}>
                      {inv.type}
                    </div>
                    <div
                      style={{
                        fontWeight: 500,
                        lineHeight: '20px',
                        fontSize: 18
                      }}>
                      {formatUSD(inv.amount)} {USDT}
                    </div>
                  </FlexBetween>
                  <FlexBetween>
                    <div>
                      {moment.utc(inv?.dateCreated).format('DD/MM/YY')} • #
                      {inv.conversionId}
                    </div>
                    <div
                      style={{
                        color: '#B5A8A8',
                        lineHeight: '18px',
                        fontSize: 12
                      }}>
                      {inv.status}
                    </div>
                  </FlexBetween>
                </InvoicesMobile>
              </Mobile>
            </AnimatedItem>
          );
        })
      )}
      {conversions?.length >= 50 &&
        conversions?.length === countConversions && (
          <FlexJustifyCenter>
            <Button
              w='200px'
              mt='10'
              mb='20'
              onClick={() => setCountConversions((count) => count + 50)}>
              {t('show_more')}
            </Button>
          </FlexJustifyCenter>
        )}
    </AnimatedTab>
  );
};
